import { call, put, select, take, takeLatest } from 'redux-saga/effects';

import quoteService from 'services/quoteService';

import { refreshQuote } from 'store/quotes/actions';
import { QUOTE_REFRESH_ERROR, QUOTE_REFRESH_SUCCESS } from 'store/quotes/types';

import { deepCopyModal, deepCopyQuoteItem, types } from './actions';
import { getQuoteItemId } from './reducer';

export default function* root() {
  yield takeLatest(types.DEEP_COPY_QUOTE_ITEM_REQUEST, watchDeepCopyQuoteItem);
}

function* watchDeepCopyQuoteItem() {
  try {
    const quoteItemId = yield select(getQuoteItemId);

    // copy quote items
    yield call(quoteService.quoteItems.deepCopy, quoteItemId);

    yield put(refreshQuote.request());
    yield take([QUOTE_REFRESH_SUCCESS, QUOTE_REFRESH_ERROR]);

    yield put(deepCopyModal.close());
    yield put(deepCopyQuoteItem.success());
  } catch (error) {
    yield put(deepCopyQuoteItem.error(error));
  }
}
